export const AMOUNT_PER_PAGE = 4

export const ADDITIONAL_FOR_PENULTIMATE_POSITION = 2
